import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CheckCircleFaint: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fill-[#242480]/[0.08] dark:fill-[#181b21]"
      d="M0.00181942 8.20502C-0.0884835 3.87186 3.19396 0.364977 7.33642 0.0274393C11.9447 -0.34808 15.8184 3.17851 15.9937 7.6765C16.165 12.0828 12.8345 15.58 8.76514 15.9637C4.13354 16.4005 0.138707 12.8381 0.00181942 8.20502ZM7.00854 8.81238C6.92218 8.73247 6.8781 8.69413 6.83653 8.65256C6.43626 8.25196 6.03778 7.84993 5.63643 7.45076C5.26411 7.08026 4.72516 7.06234 4.37327 7.40597C4.01636 7.75461 4.02567 8.30607 4.39979 8.68266C5.02151 9.30829 5.64468 9.93248 6.26999 10.5545C6.73834 11.0203 7.2153 11.0164 7.68402 10.5477C8.9737 9.25813 10.2634 7.96853 11.5523 6.67858C11.6072 6.62376 11.6627 6.56893 11.71 6.50802C11.9791 6.16152 11.9501 5.67815 11.6437 5.36641C11.2865 5.00272 10.7525 5.00916 10.3705 5.39006C9.29406 6.46323 8.2201 7.53855 7.14722 8.61494C7.09346 8.66869 7.05763 8.74143 7.00854 8.81238Z"
    />
  </svg>
);
